<script setup>
import { computed, ref, watch } from "vue";
import { UserRound } from "@lucide/vue";

const props = defineProps({
  src: { type: String, default: "" },
  firstName: { type: String, default: "" },
  lastName: { type: String, default: "" },
  size: { type: String, default: "md" },
});

const failed = ref(false);
const sizes = {
  sm: "size-8",
  md: "size-9",
  lg: "size-11",
};
const initials = computed(() =>
  [props.firstName, props.lastName]
    .filter(Boolean)
    .map((part) => part.trim().charAt(0))
    .join("")
    .slice(0, 2)
    .toLocaleUpperCase("tr-TR"),
);

watch(
  () => props.src,
  () => (failed.value = false),
);
</script>

<template>
  <span
    :class="[
      sizes[size] || sizes.md,
      'grid shrink-0 place-items-center overflow-hidden rounded-md border border-brand-100 bg-brand-50 font-extrabold text-brand-700',
    ]"
    :title="
      [firstName, lastName].filter(Boolean).join(' ') || 'Öğrenci fotoğrafı yok'
    "
  >
    <img
      v-if="src && !failed"
      :src="src"
      alt=""
      class="size-full object-cover"
      @error="failed = true"
    />
    <span v-else-if="initials" class="text-[11px] leading-none">{{
      initials
    }}</span>
    <UserRound v-else class="size-4" aria-hidden="true" />
  </span>
</template>
